"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function FloridaZonesMap() {
  const { currentLang } = useLanguage();
  const isEs = currentLang === "es";

  const zones = [
    { label: "HVHZ", color: "#ea580c", wind: "175 mph", desc: isEs ? "Miami-Dade, Broward" : "Miami-Dade, Broward" },
    { label: "WBDR", color: "#fbbf24", wind: "140 mph", desc: isEs ? "Costa a 1 milla tierra adentro en todo el estado" : "Coastal 1mi inland statewide" },
    { label: isEs ? "Estándar" : "Standard", color: "#047857", wind: "130 mph", desc: isEs ? "Interior de Florida" : "Interior Florida" },
  ];

  return (
    <section className="py-12">
      <h2 className="text-3xl font-bold text-[#064e3b] text-center mb-8">
        {isEs ? "Zonas de Código de Viento de Florida" : "Florida Wind Code Zones"}
      </h2>

      <div className="flex flex-col items-center">
        <svg viewBox="0 0 280 400" width={280} height={400} className="mx-auto">
          <path
            d="M 60,20 L 220,20 L 240,120 L 260,160 L 220,200 L 200,260 L 220,300 L 180,340 L 160,360 L 140,380 L 120,380 L 100,360 L 80,320 L 60,260 L 40,200 L 20,140 L 40,80 L 60,20 Z"
            fill="#047857"
            stroke="#064e3b"
            strokeWidth={2}
            opacity={0.85}
          />
          <path
            d="M 140,20 L 220,20 L 240,120 L 260,160 L 220,200 L 200,240 L 180,260 L 180,200 L 200,160 L 200,120 L 180,80 L 160,40 L 140,20 Z"
            fill="#fbbf24"
            stroke="#064e3b"
            strokeWidth={2}
            opacity={0.85}
          />
          <path
            d="M 160,200 L 220,200 L 200,240 L 180,260 L 180,200 Z"
            fill="#ea580c"
            stroke="#064e3b"
            strokeWidth={2}
            opacity={0.85}
          />
          <text x={120} y={120} textAnchor="middle" fill="white" fontSize={12} fontWeight={700}>
            {isEs ? "Estándar" : "Standard"}
          </text>
          <text x={180} y={130} textAnchor="middle" fill="#064e3b" fontSize={11} fontWeight={700}>
            WBDR
          </text>
          <text x={195} y={225} textAnchor="middle" fill="white" fontSize={10} fontWeight={700}>
            HVHZ
          </text>
        </svg>

        <div className="flex flex-wrap gap-6 mt-6 justify-center">
          {zones.map((z) => (
            <div key={z.label} className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-sm" style={{ backgroundColor: z.color }} />
              <div>
                <p className="text-sm font-bold text-[#064e3b]">{z.label}</p>
                <p className="text-xs text-gray-500">
                  {z.wind} · {z.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}